import { useState } from 'react';

const faqData = [
  {
    question: 'Is this site completely free?',
    answer: 'Yes! polira.site is 100% free. There are no hidden fees, no deposits required, and no real money involved. All games use virtual credits for demonstration purposes only.'
  },
  {
    question: 'Can I win real money here?',
    answer: 'No. This is a platform designed for entertainment and education. You cannot win or lose real money. All credits are virtual and have no monetary value.'
  },
  {
    question: 'Do I need to register?',
    answer: 'No registration is required! Simply visit the site and start playing immediately. We believe in hassle-free entertainment.'
  },
  {
    question: 'Why create a social casino games site?',
    answer: 'Our mission is to provide safe entertainment while helping people understand that real gambling involves significant risks. We want to prevent financial losses by offering a risk-free alternative.'
  },
  {
    question: 'Is this site safe for all ages?',
    answer: 'While our platform is risk-free, we recommend it for adults only (18+) as it simulates gambling mechanics. We encourage responsible entertainment habits.'
  },
];

function Faq() {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleFaq = (index) => {
    setOpenIndex(prevIndex => (prevIndex === index ? -1 : index));
  };

  return (
    <section className="faq">
      <h2>❓ FREQUENTLY ASKED QUESTIONS ❓</h2>
      {faqData.map((item, index) => (
        <div className="faq-item" key={index}>
          <div className="faq-question" onClick={() => toggleFaq(index)}>
            <span>{item.question}</span>
            <span className="faq-toggle">{openIndex === index ? '▲' : '▼'}</span>
          </div>
          <div className={`faq-answer ${openIndex === index ? 'active' : ''}`}>
            {item.answer}
          </div>
        </div>
      ))}
    </section>
  );
}

export default Faq;